import _ from 'lodash'
import config from 'scoreboard/components/config'
import constants from 'scoreboard/components/constants'
import {
	shortenedAndUnshortened
} from 'scoreboard/components/format-value'
import DataType from 'scoreboard/datasets/model/data-type'
const { THRESHOLD_ID } = DataType

/**
 * Returns a formatter function for the given settings.
 *
 * @param scorecardItem the scorecard item that the data comes from
 * @param dataField the field that the data comes from. For now, that can be the
 * 					numeric constant used in v3 charts (eg constants.DATA_TYPE_SCORE,
 * 					constants.DATA_TYPE_VALUE, etc) or the ScorecardItemSeries
 * 					enum used in v4 charts (eg. 'score', 'value', etc)
 * @param {Object} opt
 * @param {String} [opt.overrideDataType] data type that should be used in the formatter,
 * 					regardless of what the scorecard item's data type is.
 * 					Example: a rollup Yes/No with # of yeses aggregation
 */
function scorecardFormatter (scorecardItem, dataField, opt = {}) {
	let isScoreSeries = dataField == constants.DATA_TYPE_SCORE || dataField == 'score'

	let dataType = isScoreSeries
		? 'score'
		: (opt.overrideDataType || scorecardItem.dataType)

	let valueToFormat = _.identity
	if (dataField == 'value') {
		let scoringType = config.scoringType(scorecardItem.scoringTypeId)
		if (scoringType.kpiValueType == 'scored-text' && dataType === THRESHOLD_ID) {
			// #46641  When charting score text value series, the chart uses the
			// score to give proportional spacing between the values. However,
			// formatValue will want the threshold-id for formatting the value.
			// #50277 make sure we only do this logic when the dataType is
			// 'threshold-id', though. Example: could be aggregated to
			// "% reaching goal"
			valueToFormat = value => {
				let threshold = getThresholdByScore({ scorecardItem, score: value })
				return threshold?.id
			}
		}
	}

	return function (value) {
		return shortenedAndUnshortened({
			value: valueToFormat(value),
			dataType,
			currencyCode: scorecardItem.currencyCode,
			precision: opt.precision ?? scorecardItem.precision
		})
	}
}

function getThresholdByScore ({ scorecardItem, score }) {
	if (_.isNil(score)) {
		return null
	}

	let scoringType = config.scoringType(scorecardItem.scoringTypeId)
	// To avoid potential floating point precision bugs, look for the threshold
	// with the closest score (instead of a simple equality check)
	return _.minBy(scoringType.thresholds, threshold => {
		return Math.abs(threshold.score - score)
	})
}

export default scorecardFormatter

scorecardFormatter.__filename__ = 'charts/chart-data/scorecard-formatter.js'
